import { retrieveFromWindow } from '../../utils'
import { ICollectionLink, ICollectionBanner, IDepartment } from './collections.interfaces'
import { IProduct } from '../product'
import { ICustomerOrder } from '../../interfaces'
import { Departments } from './collections.enums'

export const links: ICollectionLink[] = retrieveFromWindow('links', [])

// export const specialtyMenus: ICollectionLink[] = retrieveFromWindow('specialtyMenus', [])
export const weeklyMenus: ICollectionLink[] = retrieveFromWindow('weeklyMenus', [])
export const collectionsProductsOrder: Record<string, number | undefined> = retrieveFromWindow('collectionsProductsOrder')
export const specialtyMenuProducts: IProduct[] = retrieveFromWindow('specialtyMenuProducts', [])

export const freshImageSrc: string = retrieveFromWindow('freshImageSrc')
export const frozenImageSrc: string = retrieveFromWindow('frozenImageSrc')

export type ReorderProduct = {
  product: IProduct
  quantity: number
}

export const REORDER_COLLECTION_HANDLE: string = 'reorder-collection'

export const customerOrders: ICustomerOrder[] = retrieveFromWindow('customerOrders', [])
export const enableReorderCollection: boolean = retrieveFromWindow('enableReorderCollection', false)
export const reorderCollectionOrder: number = retrieveFromWindow('reorderCollectionOrder', 0)
export const reorderCollectionTitle: string = retrieveFromWindow('reorderCollectionTitle', 'Last Order')
export const reorderCollectionProductLimit: number = retrieveFromWindow('reorderCollectionProductLimit', 5)
export const reorderCollectionBanner: ICollectionBanner = retrieveFromWindow('recorderCollectionBanner', {})

export const loggedIn = retrieveFromWindow('loggedIn', false)

export const departments: IDepartment[] = [
  {
    name: 'Fresh',
    id: Departments.FRESH,
    image: freshImageSrc
  },
  {
    name: 'Frozen',
    id: Departments.FROZEN,
    image: frozenImageSrc
  }
]
